// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"BookPage_svgWrapper__3Dv-f","switch":"BookPage_switch__17by5","svgContent":"BookPage_svgContent__2ZPTH","disableSelection":"BookPage_disableSelection__2z486"};